<template>
    <div v-if="isLoading" class="add-quick-comment__mask" />
</template>

<script>
import CommentService from '../../../services/comment-service';
import WordingService from '../../../services/wording-service';
import WordingHandler from '../../../utils/wording-handler';

export default {
    name: 'AddQuickCommentDialog',
    props: {
        patentId: {
            type: String,
            default: '',
        },
        spaceId: {
            type: String,
        },
        folderId: {
            type: String,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    created() {
        this.commentService = new CommentService(this.patentId, this.spaceId, this.folderId);
        this.wordingService = new WordingService(this.patentId);
        WordingHandler.$on('addQuickComment', this.addQuickComment);
    },
    beforeDestroy() {
        WordingHandler.$off('addQuickComment', this.addQuickComment);
    },
    methods: {
        async addQuickComment() {
            let comment = {};
            const offsetMeta = WordingHandler.addOffsetMeta;
            const patentInfo = WordingHandler.patentInfo;
            this.isLoading = true;

            if (WordingHandler.addWordingId) {
                // 直接 comment
                comment = await this.commentService.createComment(patentInfo.quickComment, '', '', WordingHandler.addWordingId);
                if (!comment.comment_id) {
                    this.isLoading = false;
                    return;
                }
                WordingHandler.commentCallback(WordingHandler.addWordingId, comment.comment_id);
            } else {
                // 先划段再 comment
                const param = {
                    patent_id: patentInfo.patent_id,
                    related_patent_id: patentInfo.related_patent_id,
                    workspace_id: this.spaceId,
                    folder_id: this.folderId,
                    wording_type: 'COMMENT',
                    source: patentInfo.source,
                    lang: patentInfo.lang,
                    start: offsetMeta.startMeta,
                    end: offsetMeta.endMeta,
                    content: offsetMeta.fullText,
                };
                const { wording_id } = await this.wordingService.setWording(param);
                if (!wording_id) {
                    this.isLoading = false;
                    return;
                }
                try {
                    comment = await this.commentService.createComment(patentInfo.quickComment, '', '', wording_id);
                } catch (e) {
                    console.log(e);
                }
                if (!comment.comment_id) {
                    this.isLoading = false;
                    return;
                }
                WordingHandler.commentCallback(wording_id, comment.comment_id);
            }
            this.isLoading = false;
            // 成功后需要通知 comment 弹框更新数据
            comment.content = WordingHandler.addOffsetMeta.fullText;
            comment.source = WordingHandler.patentInfo.source;
            comment.content_lang = WordingHandler.patentInfo.content_lang;
            WordingHandler.$emit('addNewComment', comment, patentInfo.patent_id);
            WordingHandler.$emit('addQuickCommentSuccess');
            window.rvTrack('Add Wording Quick Comment', { type: patentInfo.source, content: offsetMeta.fullText, isFromWorkspace: !!this.spaceId });
        },
    },
};
</script>

<style lang="scss">
.add-quick-comment__mask {
    position: fixed;
    z-index: 9999;
    background-color: rgba(255, 255, 255, 0);
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}
</style>
